module.exports = __webpack_public_path__ + "img/ins-test.9e9f1b9e.svg";